import React, { useState, useCallback, useEffect } from 'react';
import "./personal_info.css";
import { useDropzone } from "react-dropzone";
import { fetchStates } from '../../../API/Resources/fetchStates';
import { fetchCategories } from '../../../API/Resources/fetchCategories';
import { fetchCities } from '../../../API/Resources/fetchCities';
import { BsEye, BsEyeSlash } from "react-icons/bs";

function PersonalInformation({ formData, updateFormData, setPersonalNext }) {
    const [personalFormData, setPersonalFormData] = useState(formData);
    const [locations, setLocations] = useState([]);

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const validate = (name, value) => {
        let error = "";
        switch (name) {
            case "username":
                if (!value) error = "Username is required";
                break;
            case "password":
                if (!value) error = "Password is required";
                else {
                    if (value.length < 8) {
                        error = "Password must be at least 8 characters long.";
                    }
                    if (!/[A-Z]/.test(value)) {
                        error = "Password must contain at least one uppercase letter.";
                    }
                    if (!/[a-z]/.test(value)) {
                        error = "Password must contain at least one lowercase letter.";
                    }
                    if (!/\d/.test(value)) {
                        error = "Password must contain at least one number.";
                    }
                    if (!/[@$!%*?&]/.test(value)) {
                        error = "Password must contain at least one special symbol (@$!%*?&).";
                    }
                }
                break;
            case "confirmPassword":
                if (!value) error = "Confirm password is required";
                else if (value != formData['password']) {
                    error = "Passwords does not match"
                }
                break;
            case "vendor_name":
                if (!value) error = "Vendor name is required";
                break;
            case "email":
                if (!value) error = "Email is required";
                else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Invalid email format";
                break;
            case "phone_no":
                if (!value) error = "Phone number is required";
                else if (!/^\d{10}$/.test(value)) error = "Phone number must be 10 digits";
                break;
            case "state":
                if (!value) error = "state is required";
                break;
            case "city":
                if (!value) error = "city is required";
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPersonalFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: validate(name, value)
        }));
    };

    useEffect(() => {
        const loadStates = async () => {
            const loc = await fetchStates();
            setStates(loc);
        }
        loadStates();
    }, []);

    useEffect(() => {
        const loadCities = async () => {
            if (!formData.state) return;
            const loc = await fetchCities(formData.state);
            setCities(loc);
        };
        loadCities();
    }, [formData.state]);


    useEffect(() => {
        updateFormData(personalFormData);

        const requiredFields = ["username", "password", "vendor_name", "email", "phone_no", "state", "city"];

        const allFieldsFilled = requiredFields.every((field) => personalFormData[field]?.trim() !== "");

        const noErrors = requiredFields.every((field) => !errors[field]);

        setPersonalNext(allFieldsFilled && noErrors);
    }, [personalFormData, errors, updateFormData, setPersonalNext]);

    useEffect(() => {
        updateFormData(personalFormData);
    }, [personalFormData, updateFormData]);

    return (
        <div className='personal-info-form'>
            <section className='title'>
                <h1>Personal Information</h1>
            </section>
            <div className='form-section'>
                <div className="mb-3">
                    <input
                        type="text"
                        className={`form-control form-control-lg ${errors["username"] ? "is-invalid" : ""}`}
                        name="username"
                        placeholder="Username"
                        value={formData.username || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["username"] && <div className="invalid-feedback">{errors["username"]}</div>}
                </div>

                <div className="mb-3">
                    <div className="position-relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            className={`form-control form-control-lg ${errors["password"] ? "is-invalid" : ""}`}
                            name="password"
                            placeholder="Password"
                            value={formData.password || ""}
                            onChange={handleChange}
                            autoComplete='off'
                        />
                        <span
                            onClick={() => setShowPassword(!showPassword)}
                            className="password-toggle-icon-left"
                            aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? <BsEyeSlash size={20} /> : <BsEye size={20} />}
                        </span>
                    </div>
                    {errors["password"] && <div className="invalid-feedback d-block">{errors["password"]}</div>}
                </div>

                <div className="mb-3">
                    <div className="position-relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            className={`form-control form-control-lg ${errors["confirmPassword"] ? "is-invalid" : ""}`}
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={formData.confirmPassword || ""}
                            onChange={handleChange}
                            autoComplete='off'
                        />
                        <span
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="password-toggle-icon-left"
                            aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? <BsEyeSlash size={20} /> : <BsEye size={20} />}
                        </span>
                    </div>
                    {errors["confirmPassword"] && <div className="invalid-feedback d-block">{errors["confirmPassword"]}</div>}
                </div>

                <div className="mb-3">
                    <input
                        type="text"
                        className={`form-control form-control-lg ${errors["vendor_name"] ? "is-invalid" : ""}`}
                        name="vendor_name"
                        placeholder="Vendor_name"
                        value={formData.vendor_name || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["vendor_name"] && <div className="invalid-feedback">{errors["vendor_name"]}</div>}
                </div>

                <div className="mb-3">
                    <input
                        type="email"
                        className={`form-control form-control-lg ${errors["email"] ? "is-invalid" : ""}`}
                        name="email"
                        placeholder="Email"
                        value={formData.email || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["email"] && <div className="invalid-feedback">{errors["email"]}</div>}
                </div>

                <div className="mb-3">
                    <input
                        type="text"
                        className={`form-control form-control-lg ${errors["phone_no"] ? "is-invalid" : ""}`}
                        name="phone_no"
                        placeholder="Phone Number"
                        value={formData.phone_no || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["phone_no"] && <div className="invalid-feedback">{errors["phone_no"]}</div>}
                </div>

                <div className="mb-3">
                    <select
                        className={`form-control form-control-lg ${errors["state"] ? "is-invalid" : ""}`}
                        name="state"
                        value={formData.state || ""}
                        onChange={handleChange}
                    >
                        <option value="" disabled>Select a state</option>
                        {states.map((state) => (
                            <option key={state} value={state}>
                                {state}
                            </option>
                        ))}
                        {/* Add other cities here */}
                    </select>
                    {errors["state"] && <div className="invalid-feedback">{errors["state"]}</div>}
                </div>

                <div className="mb-3">
                    <select
                        className={`form-control form-control-lg ${errors["city"] ? "is-invalid" : ""}`}
                        name="city"
                        value={formData.city || ""}
                        onChange={handleChange}
                        disabled={formData['state'] == ''}
                    >
                        <option value="" disabled>Select a city</option>
                        {cities.map((city) => (
                            <option key={city} value={city}>
                                {city}
                            </option>
                        ))}
                    </select>
                    {errors["city"] && <div className="invalid-feedback">{errors["city"]}</div>}
                </div>

            </div>
        </div>
    );
}

function BusinessInformation({ formData, updateFormData, setPersonalNext }) {
    const [businessFormData, setBusinessFormData] = useState(formData);
    const [errors, setErrors] = useState({});
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        setPersonalNext(false);

        const fetchCategory = async () => {
            const cat = await fetchCategories();
            setCategories(cat)
        }

        // fetchUser();
        fetchCategory();

        const message = sessionStorage.getItem("message");
        if (message) {
            setOpen(true);
        }

    }, []);

    useEffect(() => {
        updateFormData(businessFormData);
    }, [businessFormData, updateFormData]);

    const validate = (name, value) => {
        let error = "";
        switch (name) {
            case "business_name":
                if (!value.trim()) error = "Business name is required";
                break;
            case "business_category":
                if (!value.trim()) error = "Business category is required";
                break;

            case "gst_number":
                const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;
                if (!gstRegex.test(value)) {
                    error = "Invalid GST Number format";
                }
                break;

            default:
                break;
        }
        return error;
    };


    useEffect(() => {
        updateFormData(businessFormData);

        const requiredFields = ["business_name", "business_category"];

        const allFieldsFilled = requiredFields.every((field) => businessFormData[field]?.trim() !== "");

        const noErrors = requiredFields.every((field) => !errors[field]);

        setPersonalNext(allFieldsFilled && noErrors);
    }, [businessFormData, errors, updateFormData, setPersonalNext]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBusinessFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: validate(name, value)
        }));
    };

    return (
        <div className='business-info-form'>
            <section className='title'>
                <h1>Business Information</h1>
            </section>

            <div className='form-section'>
                <div className="mb-3">
                    <input
                        type="text"
                        className={`form-control form-control-lg ${errors["business_name"] ? "is-invalid" : ""}`}
                        name="business_name"
                        placeholder="Business name"
                        value={formData.business_name || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["business_name"] && <div className="invalid-feedback">{errors["business_name"]}</div>}
                </div>



                <div className="mb-3">
                    <select
                        className={`form-control form-control-lg ${errors["business_category"] ? "is-invalid" : ""}`}
                        name="business_category"
                        value={formData.business_category || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    >
                        <option value="">Select Business Category</option>
                        {categories.map((category) => (
                            <option key={category.id} value={category.category_name}>
                                {category.category_name}
                            </option>
                        ))}
                        {/* Add more categories as needed */}
                    </select>
                    {errors["business_category"] && (
                        <div className="invalid-feedback">{errors["business_category"]}</div>
                    )}
                </div>


                <div className="mb-3">
                    <input
                        type="text"
                        className={`form-control form-control-lg ${errors["gst_number"] ? "is-invalid" : ""}`}
                        name="gst_number"
                        placeholder="GST Number"
                        value={formData.gst_number || ""}
                        onChange={handleChange}
                        autoComplete='off'
                    />
                    {errors["gst_number"] && <div className="invalid-feedback">{errors["gst_number"]}</div>}
                </div>
            </div>
        </div>
    );
}



const DocumentUpload = ({ formData, updateFormData, setPersonalNext }) => {
    const [uploadedDocuments, setUploadedDocuments] = useState(formData);

    useEffect(() => {
        setPersonalNext(false);
    }, []);

    useEffect(() => {
        updateFormData(uploadedDocuments);
        const requiredFields = ["vendor_aadharCard", "vendor_PAN", "business_PAN", "electricity_bill", "business_photos", "liscence"];
        const allFieldsFilled = requiredFields.every(
            (field) => uploadedDocuments[field] instanceof File || (Array.isArray(uploadedDocuments[field]) && uploadedDocuments[field].length > 0)
        );
        setPersonalNext(allFieldsFilled ? true : false);
    }, [uploadedDocuments, updateFormData, setPersonalNext]);

    const handleFileDrop = (fieldName, isMultiple = false) => (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const files = isMultiple ? [...(uploadedDocuments[fieldName] || []), ...acceptedFiles] : acceptedFiles[0];
            setUploadedDocuments((prevState) => ({
                ...prevState,
                [fieldName]: files,
            }));
            updateFormData({
                [fieldName]: files,
            });
        }
    };

    const handleFileRemove = (fieldName) => {
        setUploadedDocuments((prevState) => ({
            ...prevState,
            [fieldName]: null,
        }));
        updateFormData({
            [fieldName]: null,
        });
    };

    const handleMultipleFileRemove = (fieldName, index) => {
        setUploadedDocuments((prevState) => {
            const updatedFiles = prevState[fieldName].filter((_, i) => i !== index);
            return {
                ...prevState,
                [fieldName]: updatedFiles,
            };
        });
        updateFormData({
            [fieldName]: uploadedDocuments[fieldName].filter((_, i) => i !== index),
        });
    };

    return (
        <div className="personal-info-form">
            <section className="title">
                <h1>Upload Documents</h1>
                <p>Please upload the required documents to complete your registration.</p>
            </section>
            <section className='file-container'>
                <FileUpload
                    label="Aadhar Card"
                    file={uploadedDocuments["vendor_aadharCard"]}
                    onDrop={handleFileDrop("vendor_aadharCard", false)}
                    onRemove={() => handleFileRemove("vendor_aadharCard")}
                />
                <FileUpload
                    label="PAN Card"
                    file={uploadedDocuments["vendor_PAN"]}
                    onDrop={handleFileDrop("vendor_PAN", false)}
                    onRemove={() => handleFileRemove("vendor_PAN")}
                />
                <FileUpload
                    label="Business PAN"
                    file={uploadedDocuments["business_PAN"]}
                    onDrop={handleFileDrop("business_PAN", false)}
                    onRemove={() => handleFileRemove("business_PAN")}
                />
                <FileUpload
                    label="Electricity Bill"
                    file={uploadedDocuments["electricity_bill"]}
                    onDrop={handleFileDrop("electricity_bill", false)}
                    onRemove={() => handleFileRemove("electricity_bill")}
                />
                <FileUpload
                    label="License"
                    file={uploadedDocuments["liscence"]}
                    onDrop={handleFileDrop("liscence", false)}
                    onRemove={() => handleFileRemove("liscence")}
                />
                <FileUpload
                    label="Business Photos"
                    subLabel="(Include at least 1 vendor's photo also)"
                    file={uploadedDocuments["business_photos"]}
                    onDrop={handleFileDrop("business_photos", true)}
                    onRemove={(index) => handleMultipleFileRemove("business_photos", index)}
                    isMultiple
                />
            </section>
        </div>
    );
};

const FileUpload = ({ label, subLabel, file, onDrop, onRemove, isMultiple }) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'application/pdf': []
        },
        maxSize: 1024 * 1024, // 1MB
        multiple: isMultiple,
    });

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    const renderFilePreview = (f, index) => {
        const isImage = f.type.startsWith('image/');
        return (
            <div key={index} className="file-preview-item">
                <div className="file-icon">
                    {isImage ? <img src={URL.createObjectURL(f)} alt="preview" /> : '📄'}
                </div>
                <div className="file-details">
                    <span className="file-name">{f.name}</span>
                    <span className="file-size">{formatBytes(f.size)}</span>
                </div>
                <button className="remove-btn" onClick={() => isMultiple ? onRemove(index) : onRemove()}>
                    &times;
                </button>
            </div>
        );
    };

    return (
        <div className="file-upload-wrapper">
            <label className='file-label'>
                {label}
                {subLabel && <small>{subLabel}</small>}
            </label>
            {(!file || (isMultiple && file.length === 0)) ? (
                <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
                    <input {...getInputProps()} />
                    <div className="dropzone-content">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                        <p><b>Click to upload</b> or drag and drop</p>
                        <small>JPEG, PNG, or PDF (max. 1MB)</small>
                    </div>
                </div>
            ) : (
                <div className="file-preview-container">
                    {isMultiple ? file.map(renderFilePreview) : renderFilePreview(file)}
                    {isMultiple && (
                        <div {...getRootProps()} className="dropzone-add-more">
                            <input {...getInputProps()} />
                            <p>+ Add more files</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};


export { PersonalInformation, BusinessInformation, DocumentUpload };


